<template><div><h1>VUX V2.2.1Rc.7 发布日志</h1>
<h2><a href="/zh-CN/components/popup-picker.html">PopupPicker</a></h2>
<ul><li>[fix] 修复 popup-picker 上个版本转换值的问题</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.2.1Rc.7 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.2.1-rc.7-224.vue?443fb7b4